import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ServiceDeliveryDuration } from './service-delivery-duration.model';
import * as ServiceDeliveryDurationActions from './service-delivery-duration.actions';

export const serviceDeliveryDurationsFeatureKey = 'serviceDeliveryDurations';

export interface State extends EntityState<ServiceDeliveryDuration> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ServiceDeliveryDuration> = createEntityAdapter<ServiceDeliveryDuration>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(ServiceDeliveryDurationActions.addServiceDeliveryDuration,
    (state, action) => adapter.addOne(action.serviceDeliveryDuration, state)
  ),
  on(ServiceDeliveryDurationActions.upsertServiceDeliveryDuration,
    (state, action) => adapter.upsertOne(action.serviceDeliveryDuration, state)
  ),
  on(ServiceDeliveryDurationActions.addServiceDeliveryDurations,
    (state, action) => adapter.addMany(action.serviceDeliveryDurations, state)
  ),
  on(ServiceDeliveryDurationActions.upsertServiceDeliveryDurations,
    (state, action) => adapter.upsertMany(action.serviceDeliveryDurations, state)
  ),
  on(ServiceDeliveryDurationActions.updateServiceDeliveryDuration,
    (state, action) => adapter.updateOne(action.serviceDeliveryDuration, state)
  ),
  on(ServiceDeliveryDurationActions.updateServiceDeliveryDurations,
    (state, action) => adapter.updateMany(action.serviceDeliveryDurations, state)
  ),
  on(ServiceDeliveryDurationActions.deleteServiceDeliveryDuration,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ServiceDeliveryDurationActions.deleteServiceDeliveryDurations,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ServiceDeliveryDurationActions.loadServiceDeliveryDurations,
    (state, action) => adapter.setAll(action.serviceDeliveryDurations, state)
  ),
  on(ServiceDeliveryDurationActions.clearServiceDeliveryDurations,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
